module.exports = __webpack_public_path__ + "img/lari-icon.1e52e342.svg";